export default function ProductSlider({ slider }) {
    const cdnUrl = "https://kubota.sirv.com/bmk_lp/prodimages/bannerimages";
    // Most banner.url values are CDN-relative paths, but some banners need a
    // custom, fully-qualified image (e.g. a one-off Sirv-hosted asset) — use
    // those as-is instead of prefixing the CDN URL onto an already-complete link.
    const getBannerUrl = (url) => url.startsWith('https') ? url : cdnUrl + url;
    slider.banners.sort((a, b) => a.sort - b.sort);

    return (
        <div id="product_groups_container_slider" className="sliderContainerContent">
            <div id="carouselModels" className="carousel slide modelSlider" data-bs-ride="carousel">
                <div className="carousel-indicators modelSliderBullets">
                    {slider.banners.map((banner, index) => (
                        <button key={index} type="button" data-bs-target="#carouselModels" data-bs-slide-to={index} className={index === 0 ? " active" : ""} aria-label={'Go to ' + banner.headline} ></button>

                    ))}
                </div>
                <div className="carousel-inner">
                    {slider.banners.map((banner, index) => (
                        <div key={index} className={"carousel-item modelCarouselContainer" + (index === 0 ? " active" : "")} style={{ backgroundImage: 'url(' + getBannerUrl(banner.url) + ')' }} data-banner-text={banner.headline}>
                            <img src={getBannerUrl(banner.url)} className="d-block w-100" alt={slider.keyValue + ' (' + banner.headline + ')'} />
                            <div className="carousel-caption d-none d-md-block modelCarouselCaptionContainer">
                                <span className="sliderModel">{slider.keyName}</span>
                                <span className="positionHeadline">{banner.headline}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
